import React from "react";
import { connect } from "react-redux";

// Components
import BodyWrap from "../utils/BodyWrap";
import SocialNav from "./SocialNav";
import ContactInfo from "./ContactInfo";

// CSS
import "../../css/footer/footer.css";

class Footer extends React.PureComponent {
	render() {
		const { siteInfo } = this.props;

		return (
			<footer>
				<BodyWrap>
					<div className="footer-section-left">
						<img
							className="footer-logo"
							src={`/images/CCA-homepage-footer.png`}
							alt={!!siteInfo.site ? siteInfo.site.title : null}
						/>
						<ContactInfo />
					</div>
					<div className="footer-section-right">
						<SocialNav />
					</div>
				</BodyWrap>
			</footer>
		);
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo
	};
};

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js